module.exports = __webpack_public_path__ + "static/media/22.d577418c.png";